import { useNavigate } from '@tanstack/react-router'
import { omit, omitBy } from 'lodash'

import { NotificationCenterSearchType, notificationsRoute } from '../routes'

const NOTIFICATION_CENTER_URL = '/notification-center'

export const useNotificationCenterSearch = () => {
  const navigate = useNavigate()
  const search = notificationsRoute.useSearch()

  const navigateToNotificationCenter = (newSearch: Partial<NotificationCenterSearchType>) => {
    const targetSearch = omitBy(newSearch, (value) => !value || (Array.isArray(value) && value.length === 0))
    navigate({ to: NOTIFICATION_CENTER_URL, search: targetSearch })
  }

  const setSearch = (newSearch: Partial<NotificationCenterSearchType>) =>
    navigateToNotificationCenter({ ...search, ...newSearch })

  const removeParams = (params: string[]) => {
    navigateToNotificationCenter(omit(search, params))
  }

  const clearFilters = () => {
    navigate({ to: NOTIFICATION_CENTER_URL })
  }

  return { search: search || {}, setSearch, removeParams, clearFilters }
}
